import { MergeButton } from './MergeButton'
import { useRootStore } from '../../stores/RootStore'
import { Comment } from 'types'

interface Props {
  comment: Comment
}

export const MergeCommentControl = ({ comment }: Props) => {
  const rootStore = useRootStore()
  const resolveComment = () => rootStore.comments.toggleResolved(comment.id)

  return <MergeButton onPress={resolveComment} />
}
